





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import Contextmenu from '@/components/Contextmenu.vue'

@Component({
  components: {
    Contextmenu,
  },
})
export default class ConnectionsList extends Vue {
  @Prop({ required: true }) public data!: ConnectionModel[] | []
  @Prop({ required: true }) public connectionId!: string

  @Action('UNREAD_MESSAGE_COUNT_INCREMENT') private unreadMessageIncrement!: (payload: UnreadMessage) => void

  @Getter('activeConnection') private activeConnection: Client | undefined
  @Getter('unreadMessageCount') private unreadMessageCount: UnreadMessage | undefined
  @Getter('currentTheme') private theme!: Theme

  private showContextmenu: boolean = false
  private selectedConnection: ConnectionModel | null = null
  private contextmenuConfig: ContextmenuModel = {
    top: 0,
    left: 0,
  }

  @Watch('showContextmenu')
  private handleShowContextmenuChange(val: boolean) {
    if (!val) {
      this.selectedConnection = null
    }
  }

  private handleSelectConnection(row: ConnectionModel) {
    this.initUnreadMessageCount(row.id as string)
    this.$router.push({ path: `/recent_connections/${row.id}` })
  }

  private initUnreadMessageCount(id: string) {
    this.unreadMessageIncrement({ id, unreadMessageCount: 0 })
  }

  private handleContextMenu(row: ConnectionModel, event: MouseEvent) {
    if (!this.showContextmenu) {
      const { clientX, clientY } = event
      this.contextmenuConfig.top = clientY
      this.contextmenuConfig.left = clientX
      this.showContextmenu = true
      this.selectedConnection = row
    } else {
      this.showContextmenu = false
    }
  }

  private handleDelete() {
    this.$emit('delete', this.selectedConnection)
  }

  private copyText(text?: string, target?: string) {
    if (!text || !target) {
      return
    }
    this.$copyText(text)
      .then(() => {
        this.$message.success(this.$t('common.copyTargetSuccess', { target }) as string)
      })
      .catch(() => {
        this.$message.error(this.$t('common.copyTargetFailed', { target }) as string)
      })
      .finally(() => {
        this.showContextmenu = false
      })
  }

  private getBrokerAddress(connection?: ConnectionModel | null) {
    if (!connection) {
      return ''
    }
    const protocol = connection.protocol || 'mqtt'
    return `${protocol}://${connection.host}:${connection.port}`
  }

  private handleCopyHost() {
    this.copyText(this.selectedConnection?.host, 'Host')
  }

  private handleCopyBrokerAddress() {
    this.copyText(this.getBrokerAddress(this.selectedConnection), 'Broker')
  }
}
